import type { RegistryEntry, UiOption } from './types';
import { elevenlabsConfigs } from './configs/elevenlabs';
import { minimaxConfigs } from './configs/minimax';
import { bytedanceConfigs } from './configs/bytedance';
import { murekaConfigs } from './configs/mureka';

export type {
  UiOption,
  UiOptionSwitch,
  UiOptionSlider,
  UiOptionNumber,
  UiOptionSelect,
  UiOptionInput,
} from './types';

/**
 * 各厂商/模型族的 UI 选项配置，按文件拆分（见 ./configs）。
 * 新增模型时，请在对应厂商的 config 文件里添加，并在此处合并。
 */
const registry: Record<string, RegistryEntry> = {
  ...elevenlabsConfigs,
  ...minimaxConfigs,
  ...bytedanceConfigs,
  ...murekaConfigs,
};

export const getUiOptionsForModel = (modelId: string): UiOption[] =>
  registry[modelId]?.options ?? [];

export const getInitialModelUi = (
  modelId: string,
  existing?: Record<string, any>,
): Record<string, any> | undefined => {
  const opts = registry[modelId]?.options;
  if (!opts) return undefined;
  let patch: Record<string, any> | undefined;
  for (const opt of opts) {
    if (opt.type === 'input' && opt.defaultFn && !existing?.[opt.key]) {
      patch ??= {};
      patch[opt.key] = opt.defaultFn();
    }
  }
  return patch ? { ...(existing ?? {}), ...patch } : undefined;
};

export const buildProviderOptions = (
  modelId: string,
  ui: Record<string, any>
): Record<string, any> => registry[modelId]?.toProviderOptions(ui) ?? {};
